import { CanvasTexture, type Scene } from "three"
import { createOffscreenCanvas } from "../../canvas/create_canvas"
import { getCanvas2dContext } from "../../canvas/get_canvas_2d_context"

function createGoldenHourTexture(): CanvasTexture {
  const canvas = createOffscreenCanvas(256, 256)
  const ctx = getCanvas2dContext(canvas)

  if (ctx) {
    // Create gradient (top to bottom)
    const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height)
    
    // Golden hour color palette (top to bottom)
    gradient.addColorStop(0, "#000000")   // Vibrant orange-red (top of sky)
    gradient.addColorStop(0.3, "#FF9F1C") // Golden yellow (mid-sky)
    gradient.addColorStop(0.6, "#FFBF69") // Soft gold (lower sky)
    gradient.addColorStop(0.9, "#CBF3F0") // Pale blue (horizon)
    gradient.addColorStop(1, "#2EC4B6")   // Teal (ground level)

    // Apply gradient to canvas
    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, canvas.width, canvas.height)
  }

  // Convert to Three.js texture
  const texture = new CanvasTexture(canvas)
  texture.needsUpdate = true
  return texture
}

export default function createGoldenHourTextureSky(scene: Scene): void {
  scene.background = createGoldenHourTexture()
}
